import * as Yup from 'yup';

export const formInitialValues = {
  email: '',
  phone: '',
};

export default Yup.object().shape({
  email: Yup.string()
    .email('profile_change_form_bad_value')
    .required('profile_change_form_required'),

  phone: Yup.string()
    .matches(
      /^((\+)(\d{3})([ ]?))((\d{3})([ ]?)){2}(\d{3})$/,
      'profile_change_form_bad_value_phone'
    )
    .required('profile_change_form_required'),
});
